/** @format */
import { css } from 'styled-components';

import { theme } from '@toucan/config/theme';

import { StyledMarketOptionProps } from './types';

const baseStyles = ({ $showTranslations }: StyledMarketOptionProps) => css`
    padding: var(--layout-spacing-8);
    border-radius: 0.5rem;
    cursor: pointer;
    display: grid;
    grid-template-columns: auto 1fr;
    grid-column-gap: var(--layout-spacing-12);
    grid-template-rows: 1fr 1fr;
    align-items: center;
    text-decoration: none;
    color: var(--colors-text-secondary);
    transition: background-color;
    transition-duration: 0.2s;
    transition-timing-function: ease-in-out;
    margin-bottom: var(--layout-spacing-8);

    &:hover,
    &:focus {
        background-color: var(--colors-surface-secondary);
    }

    &:last-of-type {
        margin-bottom: 0;
    }

    ${!$showTranslations &&
    css`
        padding: var(--layout-spacing-12) var(--layout-spacing-8);

        .market-message {
            grid-row: span 2;
        }
    `}

    .flag {
        grid-row: span 2;
    }

    .market-translation {
        ${theme.typography.body_small}
    }
`;

export const styles = (props: StyledMarketOptionProps) => css`
    ${baseStyles(props)}
`;
